import React        from 'react';
import PropTypes    from 'prop-types';
import ReloadHelper from "../../utils/ReloadHelper";
import Translations from "../../utils/Translations";

class ActorAvatar extends React.Component {

	constructor(props) {
        super(props);
		this.onClick = this.onClickHandler.bind(this);
	}

	/**
	 * @param {Event} e
	 * @return {*|void}
	 */
	onClickHandler(e) {
		return ReloadHelper.reload(this.props.url, e);
	}

	/**
	 * @return {*}
	 */
	render() {
		// do not show if not supposed to
		if (this.props.idx < this.props.offset
			|| this.props.idx >= this.props.offset + this.props.rowSize
		) {
			return null;
		}

		const avatarClass = this.props.isOnline ? 'girls-from-this-post__circle -is-online' : 'girls-from-this-post__circle',
		      title       = this.props.name + '(' + this.props.age + ')';

		return (
			<a href={this.props.url} className="js-pjax-link girls-from-this-post__list-item fade-in" onClick={this.onClick}>
				<span className={avatarClass}
				      title={title}
				      style={{backgroundImage: 'url(' + this.props.image + ')'}}
				/>
				<span className="girls-from-this-post__name">
					{this.props.isOnline ? <span className="girls-from-this-post__online -large">&#9679;&nbsp;</span> : null}
					{this.props.name}
				</span>
				{this.props.isOnline
					? <span className="girls-from-this-post__online">{Translations.get('MagazineActorsFromThisPostOnline')}</span>
					: <span className="girls-from-this-post__offline">{Translations.get('MagazineActorsFromThisPostOffline')}</span>
				}
			</a>
		);
	}
}

ActorAvatar.propTypes = {
	idx:      PropTypes.number.required,
	name:     PropTypes.string.required,
	age:      PropTypes.number.required,
	url:      PropTypes.string.required,
	offset:   PropTypes.number,
	rowSize:  PropTypes.number,
	isOnline: PropTypes.bool,
	image:    PropTypes.string,
};

/**
 * @type {{isOnline: boolean, offset: number, rowSize: number}}
 */
ActorAvatar.defaultProps = {
	isOnline: false,
	offset:   0,
	rowSize:  7,
};

export default ActorAvatar;
